<mat-toolbar color="primary" style="display: flex; flex-direction: row;justify-content: space-between; align-items: center;" 
    class="sidenav-header ">
    <a color="accent" routerLink="/" (click)="closeSubMenus()" style="width: 50px;" class="small-logo">
        <img class="logo-image" src="./assets/img/NexusLogo.png">
    </a>
</mat-toolbar>

<div style="display:flex; flex-direction:column; justify-content:center; align-items:center;" class="user-block transition-2" 
    [class.show]="settings.sidenavUserBlock">

    <div style="display:flex; flex-direction:row; justify-content: space-around; align-items: center;"
        class="user-info-wrapper">
        <div>
            <img [src]="userImage" alt="user-image">
        </div>
    </div>
    <div class="user-info" style="display:flex; flex-direction:row; justify-content:center; align-items:center;">
        <div class="name" style="padding-left: 3px;">(<b>{{userName}}</b>)</div>
    </div>
</div>

<mat-select placeholder="{{'Menu.Order.Title' | translate}}" (selectionChange)="onOrderSelected($event)">
    <mat-option [value]="0">{{"Menu.Order.Alphabetical" | translate}}</mat-option>
    <mat-option [value]="1">{{"Menu.Order.Config" | translate}}</mat-option>
</mat-select>


<div>
    <span *ngIf="loading">{{'General.Application.Loading' | translate}}</span>
    <app-vertical-menu *ngIf="!loading" [menuItems]="menuItems" [menuParentId]="0" > 
    </app-vertical-menu>
    <br />
</div>
